import { ATTENTION_KIND } from '@klopotun/domain';
import type { AttentionAmount, AttentionItem, AttentionList } from '../../model/attention.js';
import type {
  AttentionAmountDto,
  AttentionItemDto,
  AttentionListDto,
} from '../dto/attention.dto.js';

const toAttentionAmount = (dto: AttentionAmountDto | null): AttentionAmount | null => {
  if (dto === null) {
    return null;
  }

  if (dto.kind === 'range') {
    return {
      kind: 'range',
      minMinor: dto.minMinor,
      maxMinor: dto.maxMinor,
      currency: dto.currency,
    };
  }

  return { kind: 'fixed', amountMinor: dto.amountMinor, currency: dto.currency };
};

const toAttentionItem = (dto: AttentionItemDto): AttentionItem => {
  switch (dto.kind) {
    case ATTENTION_KIND.CHARGE_SOON:
      return {
        kind: dto.kind,
        id: dto.id,
        paymentId: dto.paymentId,
        name: dto.name,
        daysLeft: dto.daysLeft,
        amount: toAttentionAmount(dto.amount),
        isLowBalance: dto.isLowBalance,
      };
    case ATTENTION_KIND.YEARLY_SOON:
      return {
        kind: dto.kind,
        id: dto.id,
        paymentId: dto.paymentId,
        name: dto.name,
        daysLeft: dto.daysLeft,
        amount: toAttentionAmount(dto.amount),
        cancelUrl: dto.cancelUrl,
        isLowBalance: dto.isLowBalance,
      };
    case ATTENTION_KIND.PAY_YOURSELF:
      return {
        kind: dto.kind,
        id: dto.id,
        paymentId: dto.paymentId,
        occurrenceId: dto.occurrenceId,
        name: dto.name,
        daysOverdue: dto.daysOverdue,
        unpaidCount: dto.unpaidCount,
        amount: toAttentionAmount(dto.amount),
      };
    case ATTENTION_KIND.MISSED_CHARGE:
      return {
        kind: dto.kind,
        id: dto.id,
        paymentId: dto.paymentId,
        name: dto.name,
        dueDate: dto.dueDate,
        isStopped: dto.isStopped,
      };
    case ATTENTION_KIND.NEW_SUBSCRIPTION:
      return {
        kind: dto.kind,
        id: dto.id,
        paymentId: dto.paymentId,
        name: dto.name,
        dueDate: dto.dueDate,
        amount: toAttentionAmount(dto.amount),
        intervalUnit: dto.intervalUnit,
      };
    case ATTENTION_KIND.PRICE_CHANGED:
      return {
        kind: dto.kind,
        id: dto.id,
        paymentId: dto.paymentId,
        name: dto.name,
        previousAmountMinor: dto.previousAmountMinor,
        amountMinor: dto.amountMinor,
        currency: dto.currency,
        changedOn: dto.changedOn,
      };
  }
};

export const toAttentionList = (dto: AttentionListDto): AttentionList => ({
  today: dto.today,
  items: dto.items.map(toAttentionItem),
});
